<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        <span v-if="optionTotalCount" class="is-size-6">{{optionTotalCount}} Option<span
          v-if="optionTotalCount && optionTotalCount > 1">s</span></span>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-marginless-bottom" v-if="options && options.length">
      <thead>
      <tr class="is-size-6">
        <th><span>Statut</span></th>
        <th><span>Lot</span></th>
        <th><span>Programme</span></th>
        <th><span>Vendeur</span></th>
        <th><span>Acheteur</span></th>
        <th><span>Date de création</span></th>
      </tr>
      </thead>
      <tbody class="is-size-5 has-text-text">
      <tr v-for="(option, i) in options" class="is-size-6">
        <td>
          <span class="tag" :class="statusColor(option.status)">{{optionStatus[option.status].label}}</span>
        </td>
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'LotVue', params: {id: option.lot.pk || option.lot}}" class="fullLink">
            {{option.lot_ref}}
          </router-link>
        </td>
        <td>
          <span>{{option.program_name}}</span>
        </td>
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'UserVue', params: {id: option.seller}}">{{option.seller_name}}</router-link>
        </td>
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'ContactVue', params: {id: option.buyer}}">{{option.buyer_name}}</router-link>
        </td>
        <td>
          <span>{{ option.created_on | prettyDatetime }}</span>
        </td>
      </tr>
      <tr v-if="pagination.pages > 1 && nextPage">
        <td width="33%"></td>
        <td width="33%"><infinite-loading spinner="waveDots" @infinite="infiniteHandler"></infinite-loading></td>
        <td width="33%"></td>
      </tr>
      </tbody>
    </table>
    <div class="column" v-else>Aucune option à afficher</div>
  </div>
</template>
<script>
  import { DefaultValues, OptionStatus } from '@/mixins'

  export default {
    name: 'OptionPanel',
    mixins: [DefaultValues, OptionStatus],
    props: {
      company: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        items: [],
        optionTotalCount: null,
        loading: true,
        pagination: {
          page: null,
          pages: null
        },
        service: this.$api.optionService,
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      companyPk () {
        return this.company.pk
      },
      nextPage () {
        if (!this.pagination.page || !this.pagination.pages) {
          return null
        } else {
          if (this.pagination.page && this.pagination.pages > this.pagination.page) {
            return this.pagination.page + 1
          } else {
            return null
          }
        }
      },
      options () {
        return this.items
      }
    },
    methods: {
      getOptions (callback) {
        let query = {
          // status: ['approved', 'pending', 'waiting_list'],
          company: this.companyPk,
          per_page: 100,
          page: this.nextPage,
          sort: 'created_on:desc'
        }
        this.$api.optionService.get(query).then(r => {
          this.items = this.items.concat(r.data.items)
          this.optionTotalCount = r.data.total
          this.pagination.page = r.data.page
          this.pagination.pages = r.data.pages
          if (callback) {
            callback(r.data)
          }
        })
      }
    },
    created () {
      this.getOptions()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/OptionPanel.vue